module.exports = __webpack_public_path__ + "media/images/athletes/3128-a7756d3ec41a41471523184d2773ba94.png";